import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { initializeAuthSession } from "./authApi";
import { initializeTheme } from "./lib/theme";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastProvider } from "./components/ToastProvider";
import "./styles.css";

// Material Symbols Outlined — used as our icon set across the app.
const ICON_LINK_ID = "material-symbols-outlined";
if (typeof document !== "undefined" && !document.getElementById(ICON_LINK_ID)) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.id = ICON_LINK_ID;
  link.href =
    "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&display=swap";
  document.head.appendChild(link);
}

initializeTheme();
initializeAuthSession();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
